import React from "react";
import { EnvironmentOutlined, HomeOutlined, GlobalOutlined } from "@ant-design/icons";

const ZoneStatistics = ({ total = 0, capital = 0, outside = 0 }) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
        gap: "20px",
        marginBottom: "24px",
      }}
    >
      {/* Total Zones Card */}
      <div
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          borderRadius: "12px",
          padding: "20px",
          color: "white",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <EnvironmentOutlined style={{ fontSize: "32px" }} />
          <div>
            <div style={{ fontSize: "14px", opacity: 0.9 }}>Total Zones</div>
            <div style={{ fontSize: "32px", fontWeight: "bold" }}>{total}</div>
          </div>
        </div>
      </div>

      {/* Capital Zones Card */}
      <div
        style={{
          background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
          borderRadius: "12px",
          padding: "20px",
          color: "white",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <HomeOutlined style={{ fontSize: "32px" }} />
          <div>
            <div style={{ fontSize: "14px", opacity: 0.9 }}>Capital Zones</div>
            <div style={{ fontSize: "32px", fontWeight: "bold" }}>{capital}</div>
            <div style={{ fontSize: "12px", opacity: 0.8, marginTop: "4px" }}>
              Inside Amman/Doha
            </div>
          </div>
        </div>
      </div>

      {/* Outside Capital Card */}
      <div
        style={{
          background: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
          borderRadius: "12px",
          padding: "20px",
          color: "white",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <GlobalOutlined style={{ fontSize: "32px" }} />
          <div>
            <div style={{ fontSize: "14px", opacity: 0.9 }}>Outside Capital</div>
            <div style={{ fontSize: "32px", fontWeight: "bold" }}>{outside}</div>
            <div style={{ fontSize: "12px", opacity: 0.8, marginTop: "4px" }}>
              Suburban areas
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ZoneStatistics;